var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Editor',{attrs:{"imageSource":_vm.imageSource,"jsonData":_vm.jsonData,"mapName":_vm.mapName,"gridSizeInPixels":50,"coordinatesOffset":1,"maximumZoom":150}})}
var staticRenderFns = []

export { render, staticRenderFns }